// extracted by mini-css-extract-plugin
export default {"link":"PK-z","disabled":"QK-z"};